import React from "react";
import AnchorLink from 'react-anchor-link-smooth-scroll'
import Slider from "react-slick";

export default function SimpleSlider() {
  let publicUrl = process.env.PUBLIC_URL+'/'
  var settings = {
    dots: false,
    arrows: false,
    infinite: true,
    centerMode: false,
    speed: 500,
    slidesToShow: 8,
    slidesToScroll: 2
  };
  return (
    <Slider {...settings}>
      <div class="virt">
        <AnchorLink href="#things"><h3><img src={publicUrl+"assets/img/appe.jpg"}/><br/>APPETIZERS</h3></AnchorLink>
      </div>
      <div class="virt">
        <AnchorLink href="#stuff"><h3><img src={publicUrl+"assets/img/veg.jpg"}/><br/>VEGETARIAN DISHES</h3></AnchorLink>
      </div>
      <div class="virt">
        <AnchorLink href="#CHICKEN"><h3><img src={publicUrl+"assets/img/chik.jpg"}/><br/>CHICKEN DISHES</h3></AnchorLink>
      </div>
      <div class="virt">
        <AnchorLink href="#LAMB"><h3><img src={publicUrl+"assets/img/lamb.jpg"}/><br/>LAMB DISHES</h3></AnchorLink>
      </div>
      <div class="virt">
        <AnchorLink href="#TANDOOR"><h3><img src={publicUrl+"assets/img/tand.jpg"}/><br/>TANDOOR DISHES</h3></AnchorLink>
      </div>
      <div class="virt">
        <AnchorLink href="#CHILDREN"><h3><img src={publicUrl+"assets/img/kid.jpg"}/><br/>CHILDREN DISH</h3></AnchorLink>
      </div>
      <div class="virt">
        <AnchorLink href="#SEA"><h3><img src={publicUrl+"assets/img/sea.jpg"}/><br/>SEA FOOD</h3></AnchorLink>
      </div>
      <div class="virt">
        <AnchorLink href="#"><h3><img src={publicUrl+"assets/img/side.jpg"}/><br/>SIDE ORDER</h3></AnchorLink>
      </div>
      <div class="virt">
        <AnchorLink href="#"><h3><img src={publicUrl+"assets/img/desert.jpg"}/><br/>DESSERTS</h3></AnchorLink>
      </div>
      <div class="virt">
        <AnchorLink href="#"><h3><img src={publicUrl+"assets/img/group.jpg"}/><br/>GROUP MENUS</h3></AnchorLink>
      </div>
      <div class="virt">
        <AnchorLink href="#"><h3><img src={publicUrl+"assets/img/thali.jpg"}/><br/>THALI</h3></AnchorLink>
      </div>
      <div class="virt">
        <AnchorLink href="#"><h3><img src={publicUrl+"assets/img/dri.jpg"}/><br/>DRINKS</h3></AnchorLink>
      </div>
			<div>
        <AnchorLink href="#"><h3><img src={publicUrl+"assets/img/spri.jpg"}/><br/>SPIRITS - DRINKS</h3></AnchorLink>
      </div>
    </Slider>
  );
}